/*
 * @Description: 
 * @Author: 张欢
 * @Date: 2020-04-18 10:59:48
 * @LastEditTime: 2020-10-29 15:39:29
 * @LastEditors: xutao
 */
import { YjErrorReport } from '@yunji/report'
import Vue from 'vue'
import App from '@/App.vue'
import router from './router'
import store from './store'
import './js/hostnameConfig'
import AJAX from './js/ajax'
import './js/filter'
import './css/reset.css'
import wxShare from '@/common/js/wxShare'

Vue.config.productionTip = false
Vue.prototype.AJAX = AJAX
Vue.prototype.wxShare = wxShare

Vue.config.ignoredElements = ['wx-open-launch-weapp']

//  本地环境及测试环境增加vconsole
const domain = window.location.hostname.search(/(local.|v.|t.|txst.|lb-tx.|ys-txst.|special-al-dev-tmp.|t-do-dev.)/)
if (domain === 0) {
  const script = document.createElement('script')
  const style = document.createElement('style')
  style.appendChild(document.createTextNode('.vc-table{ line-height: 1.3; }'))
  script.src = '//static.yunjiglobal.com/qnUpload/frontend/js/vconsole.dev.js'
  document.body.appendChild(script)
  document.body.appendChild(style)
}

function windowSize(doc, win) {
  const docEl = doc.documentElement
  const dpr = 1
  const scale = 1 / dpr
  docEl.dataset.dpr = win.devicePixelRatio

  const metaEl = doc.createElement('meta')
  metaEl.name = 'viewport'
  metaEl.content = `initial-scale=${scale},maximum-scale=${scale}, minimum-scale=${scale}`
  docEl.firstElementChild.appendChild(metaEl)
  // deviceWidth通过document.documentElement.clientWidth就能取到
  const recalc = function () {
    let width = doc.documentElement.clientWidth || doc.body.clientWidth
    if (width / dpr > 750) {
      width = 750 * dpr
    }
    docEl.style.fontSize = `${100 * (width / 750)}px`
  }
  recalc()
}

windowSize(document, window)
window.onresize = function () {
  windowSize(document, window)
}

/**
 * 输出JENKINS信息
 */
const returnPackage = () => {
  if (typeof window.JENKINS !== 'undefined' && window.JENKINS.packageName) {
    return {
      packageName: window.JENKINS.packageName,
      packageVersion: window.JENKINS.packageVersion
    }
  }
  return {}
}

/**
 * 错误日志监控
 */
// eslint-disable-next-line no-unused-vars
const yjerror = new YjErrorReport(Vue, {
  projectName: 'yunjiactivity',
  environment: domain === 0 ? 'test' : 'release',
  packageName: returnPackage().packageName,
  packageVersion: returnPackage().packageVersion
})

Vue.prototype.swReportfc = yjerror

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
